import Image from "next/image";
import GooglePlay from "assets/img/landing/googlePlay.png";
import MobileSection from "assets/img/landing/mobileSection.png";
import mobileSectionArabic from "assets/img/landing/mobileSectionArabic.png";

import { useTranslation } from "react-i18next";

function index() {
  const { t, i18n } = useTranslation();

  return (
    <div className="bg-[#F2F6EC] ">
      <div className="container px-5 m-auto xl:px-0 ">
        <div
          className={`py-15 text-center md:text-left md:py-0 flex justify-evenly items-center gap-36 ${
            i18n.language === "en" ? "md:text-left" : "md:text-right"
          }`}
        >
          <div>
            <div className="mb-5 text-xl font-bold md:text-3xl">
              {t("OUR MOBILE APP IS MADE FOR") + " " + t("THE FARM")}
            </div>
            <div className="mb-5 font-bold">{t("Get the app")}</div>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.platFarm.platFarm"
            >
              <Image quality={40} src={GooglePlay} alt="img" />
            </a>
          </div>
          <div className="hidden md:flex ">
            <Image
              quality={40}
              src={i18n.language === "en" ? MobileSection : mobileSectionArabic}
              alt="img"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
